import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import * as _ from 'lodash'
import * as _moment from 'moment'
import { FormControl, FormGroup } from '@angular/forms'
const moment = _moment

@Component({
  selector: 'po-sub-form',
  templateUrl: './po-sub-form.component.html',
  styleUrls: ['./po-sub-form.component.css']
})
export class PoSubFormComponent implements OnInit {
  open = true
  @Input() field
  @Input() customForm
  @Input() emptyFormSchema
  @Input() i
  @Input() controls
  @Output() addEvent = new EventEmitter<any>()

  constructor() {}

  ngOnInit() {}

  typeof(field) {
    if (_.isArray(field)) {
      return 'array'
    } else if (_.isDate(field)) {
      return 'date'
    } else if (_.isObject(field) && field['options']) {
      return 'select'
    } else if (_.isObject(field)) {
      return 'group'
    } else {
      return 'single'
    }
  }

  changeDateFormat(event) {
    const date = moment(event.value)
    if (date.isValid()) this.controls.setValue(date.format('YYYY-MM-DD'))
  }

  add(field) {
    switch (field) {
      case 'Line Items': {
        let grp = {}
        let ar = []
        for (let [key, val] of this.emptyFormSchema[this.i][1][0]) {
          grp[key] = new FormControl('')
          ar.push([key, val])
        }
        this.customForm.controls[field].push(new FormGroup(grp))
        this.emptyFormSchema[this.i][1].push(ar)
      }
    }
  }

  reduce(ind, field) {
    this.customForm.controls[field].removeAt(ind)
    this.emptyFormSchema[this.i][1].splice(ind, 1)
  }
}
